import React from 'react';
import { string, number } from 'prop-types';

import { CirclePlayIcon } from '@snapask/common-components';

import { VIDEO } from '@blueberry/constants/postType';

import { formatDurationTime, getVideoImageUrl } from '@blueberry/utils/youtube';
import { getLargeSizeForImgur } from '@blueberry/utils/image';

import styles from './MediaImage.scss';

function MediaImage({ mediaAltText, durationTime, mediaUrl, type, href }) {
  if (type === VIDEO) {
    const mediaImageUrl = getVideoImageUrl(mediaUrl);

    return (
      <a className={styles.imageBlock} href={href}>
        <img src={mediaImageUrl} className={styles.image} alt={mediaAltText} />
        <span className={styles.playIcon}>
          <CirclePlayIcon />
        </span>
        {!!durationTime && (
          <span className={styles.timeSpan}>
            {formatDurationTime(durationTime)}
          </span>
        )}
      </a>
    );
  }

  const imgUrl = getLargeSizeForImgur(mediaUrl);

  return (
    <a className={styles.imageBlock} href={href}>
      <img src={imgUrl} className={styles.image} alt={mediaAltText} />
    </a>
  );
}

MediaImage.propTypes = {
  durationTime: number.isRequired,
  href: string.isRequired,
  mediaAltText: string.isRequired,
  mediaUrl: string.isRequired,
  type: string.isRequired,
};

export default MediaImage;



// WEBPACK FOOTER //
// ./app/components/MediaImage/MediaImage.jsx